<div class="rich-editor-dialog-container">
    <div class="nova__dialog__toolbar">
        <div class="nova__dialog__toolbar__title">
            {{title}}
        </div>
        <div class="nova__dialog__toolbar__controls">
            <button class="nova__button--icon">
                <mat-icon class="nova-toolbar__controls__icon--close"
                    [mat-dialog-close]="getResult(true)">close</mat-icon>
            </button>
        </div>
    </div>
    <div mat-dialog-content class="nova__dialog__content">
        <nova-rich-editor [maxlength]="maxLength" [useIframe]="false" [formControl]="description">
        </nova-rich-editor>

        <div class="text-info-container">
            @if (description?.hasError('maxlength')) {
            <div class="error">Max limit {{ maxLength }} characters</div>
            }
        </div>

        <mat-dialog-actions class="nova__dialog__content__actions">
            <button mat-raised-button color="primary" [mat-dialog-close]="getResult()"
                [disabled]="isSaveDisabled()">save</button>
            <button mat-button [mat-dialog-close]="getResult(true)">cancel</button>
        </mat-dialog-actions>
    </div>
</div>